var map = {
	"./bold-active.svg": "Uzc0",
	"./bold.svg": "JTFV",
	"./center-active.svg": "pNmv",
	"./center.svg": "OMhQ",
	"./h1-active.svg": "7pIs",
	"./h1.svg": "xgmq",
	"./h2-active.svg": "DcbS",
	"./h2.svg": "BzW0",
	"./h3-active.svg": "9o5m",
	"./h3.svg": "oPuj",
	"./h4-active.svg": "Ih9B",
	"./h4.svg": "Y5a4",
	"./h5-active.svg": "MpBU",
	"./h5.svg": "mBBP",
	"./h6-active.svg": "keEW",
	"./h6.svg": "64Gy",
	"./italic-active.svg": "BdOg",
	"./italic.svg": "RsVA",
	"./left-active.svg": "msXy",
	"./left.svg": "azYS",
	"./normal-active.svg": "i+TM",
	"./normal.svg": "3Ocq",
	"./right-active.svg": "CcKR",
	"./right.svg": "/yfL",
	"./underline-active.svg": "3FjV",
	"./underline.svg": "dEty"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "py54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/text-label ^\.\/.*\.svg$
// module id = py54
// module chunks = 46